import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import TextareaAutosize from "react-textarea-autosize";
import Form from "../../includes/Forms";
import Loading from 'react-fullscreen-loading';
import { format } from "date-fns";
import axios from 'axios';
import * as CONST from '../../includes/Constant';
import { toast } from 'react-toastify';
import '../../../assets/css/datepicker.css';
import Swal from "sweetalert2";
import Select from 'react-select';

import { S_INR_CURRENCY_SYMBOL, S_FORMAT_INR_CURRENCY_AND_AMOUNT } from "../../includes/staticData";
import useAuthInfo from '../../../hooks/IsAdmin';
import { Row } from 'react-bootstrap';
export default function VendorPayments({ vendor_id, onClose, currentUser }) {
  const { isAdmin, eDepartmentId, eUser_id } = useAuthInfo();
  const [payments, setPayments] = useState([]);
  const [vendorId, setVendorId] = useState(vendor_id);
  const [selectedVendorId, setSelectedVendorId] = useState(vendor_id);
  const [vendorData, setVendorData] = useState([]);
  const [formData, setFormData] = useState({
    amount: "",
    payment_date: "",
    vendor_id: ""

  });
  const [loading, setLoading] = useState(false);
  const [validate, setValidate] = useState(false);

  const fetchVendors = async () => {
    setLoading(true);
    try {
      const response = await axios.get(CONST.GET_VENDOR_LIST, {
        params: {
          department_id: isAdmin ? "" : eDepartmentId
        }
      });
      if (response.data) {
 
        setVendorData(response.data.data.map(vendor => ({ value: vendor.id, label: vendor.name })));
      } else {

      }
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleVendorChange = (selectedOption) => {
    setVendorId(selectedOption);
    setSelectedVendorId(selectedOption?.value);
  };
  const validateForm = async () => {
    let isValid = true;
    let validator = Form.validator({
      amount: {
        value: formData.amount,
        isRequired: true,
        label: "amount",
      },
      payment_date: {
        value: formData.payment_date,
        isRequired: true,
        label: "received date",
      },
      ...(vendor_id === "" && {
        vendor: {
          value: vendorId,
          isRequired: true,
          label: "vendor",
        },
      }),

    });
    if (validator !== null) {
      setValidate({
        validate: validator.errors,
      });
      isValid = false;
    } else {
      isValid = true;
    }
    return isValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validate = await validateForm();
    if (validate) {
      setLoading(true);
      //const formattedDate = formData.payment_date.toISOString().slice(0, 7); // YYYY-MM
      const date = new Date(formData.payment_date);
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}`;

      const mappedFormData = {
        amount: formData.amount,
        payment_date: formattedDate,
      };

      if (mappedFormData) {
        await axios.post(CONST.ADD_VENDOR_PAYMENTS, {
          vendor_id: selectedVendorId,
          updated_by: currentUser ? currentUser : eUser_id,
          paymentData: mappedFormData,
        }).then((response) => {
          if (response) {
            const status = response.data.status;
            if (status === 'error') {
              toast.error(response.data.message);
            } else {
              // if (onClose) { onClose() }
              toast.success(response.data.message);
            }
          }
        }).catch((error) => {
          setLoading(false);
          toast.error("Something went wrong. Please try again.");
        });
      }
      setLoading(false);
    }
  }

  useEffect(() => {
    if (vendor_id === "") {
      fetchVendors();
    } else {
      setVendorId(vendor_id);
      setSelectedVendorId(vendor_id);
    }

  }, []);

  return (
    <>
      {loading && <Loading loading={loading} />}
      <div className='row'>
        <form onSubmit={handleSubmit}>
          <div className="row mb-3">
            {
              (vendor_id === "") && (
                <>
                  <Row>
                    <div className="col-8 mb-2">
                      <label className="form-label">Select Vendor</label>
                      <Select
                        options={vendorData}
                        placeholder="Select Vendor..."
                        onChange={handleVendorChange}
                        value={vendorId}
                        name="vendor"
                        className={`  ${validate.validate && validate.validate.vendor
                          ? "is-invalid"
                          : ""
                          }`}
                      />
                      {validate.validate && validate.validate.vendor && (
                        <div className="invalid-feedback">
                          {validate.validate && validate.validate.vendor}
                        </div>
                      )}
                    </div>

                  </Row>
                </>
              )
            }

            <Row>
              <div className="col-8 mb-2">
                <label className="form-label">Amount <strong>({S_INR_CURRENCY_SYMBOL('inr') || ""})</strong></label>
                <input
                  type="text"
                  className={`form-control ${validate.validate && validate.validate.amount
                    ? "is-invalid"
                    : ""
                    }`}
                  placeholder="Amount"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                />
                {validate.validate && validate.validate.amount && (
                  <div className="invalid-feedback">
                    {validate.validate && validate.validate.amount}
                  </div>
                )}
              </div>
            </Row>
            <Row>
              <div className="col-md-12 mb-2">
                <label className="form-label mb-2 w-100">Payment Date</label>
                <DatePicker
                  dateFormat="MM/yyyy"
                  selected={formData.payment_date}
                  showMonthYearPicker
                  showFullMonthYearPicker
                  onChange={(date) => setFormData((prevData) => ({ ...prevData, payment_date: date }))}
                  name="payment_date"
                  className={`form-control ${validate.validate && validate.validate.payment_date
                    ? "is-invalid"
                    : ""
                    }`}
                  placeholderText="Payment Date"

                />
                {validate.validate && validate.validate.payment_date && (
                  <div className="invalid-feedback">
                    {validate.validate && validate.validate.payment_date}
                  </div>
                )}
              </div>
            </Row>
          </div>

          <div className="row">
            <div className='col-md-12 text-left'>
              <button type="submit" value="Save" className="btn btn-primary">
                <i class='bx bx-save'></i> {" "}Save</button>
            </div>
          </div>
        </form>
      </div >
      <hr className='py-2' />

    </>
  )
}
